import {emailInputRegex} from "../../../../utils/globalConstants";
import {submitEvent} from "@otto-ec/tracking-bct";

const newsletterUnsubscribeEmailRegex = emailInputRegex
let newsletterUnsubscribeValidForm = false;

const newsletterUnsubscribeForm = document.getElementById(
  "newsletter-unsubscribe-form"
);
newsletterUnsubscribeForm?.addEventListener(
  "submit",
  newsletterUnsubscribeOnSubmitHandler
);

const newsletterUnsubscribeEmailInput = document.getElementById(
  "newsletter-unsubscribe-email-input"
) as HTMLInputElement;
newsletterUnsubscribeEmailInput?.addEventListener(
  "blur",
  validateNewsletterUnsubscribeEmailInputHandler
);

const newsletterUnsubscribeError = document.getElementById(
    "newsletter-unsubscribe-error"
);

function validateNewsletterUnsubscribeEmailInputHandler() {
  const inputValue = newsletterUnsubscribeEmailInput?.value;
  const invalidFormBanner = document.getElementById("invalid-form-banner");

  if (inputValue.match(newsletterUnsubscribeEmailRegex)) {
    newsletterUnsubscribeEmailInput.setAttribute("validation-message", "");
    invalidFormBanner!.style.display = "none";
    newsletterUnsubscribeValidForm = true;
  } else if (inputValue === "") {
    newsletterUnsubscribeEmailInput.setAttribute("validation-message", "Bitte trage eine gültige E-Mail-Adresse ein.");
    invalidFormBanner!.style.display = "none";
    newsletterUnsubscribeValidForm = false;
  } else if (inputValue.length <= 5) {
    newsletterUnsubscribeEmailInput.setAttribute("validation-message", "Deine E-Mail-Adresse darf nicht weniger als 6 Zeichen enthalten.");
    invalidFormBanner!.style.display = "none";
    newsletterUnsubscribeValidForm = false;
  } else {
    newsletterUnsubscribeEmailInput.setAttribute("validation-message", "Bitte überprüfe, ob deine eingegebene E-Mail-Adresse ein @-Zeichen und einen Punkt enthält.");
    invalidFormBanner!.style.display = "none";
    newsletterUnsubscribeValidForm = false;
  }
}

function showErrorContent() {
  newsletterUnsubscribeError!.style.display = "unset";
}

const sendNewsletterUnsubscription = async (emailInput: string) => {
  const payload = {
    email: emailInput,
  };
  try {
    const response = await fetch("/newsletter-subscription/unsubscribe", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!(response.status >= 500)) {
      trackSubmitUnsubscribeNlSuccess();
      window.location.replace("/newsletter/abmelden/erfolg/");
    } else {
      trackSubmitUnsubscribeNlFailure();
      showErrorContent();
    }
  } catch (error) {
    console.error("Something went wrong:", error.message, error.name);
    showErrorContent();
  }
};

function newsletterUnsubscribeOnSubmitHandler(e: Event) {
  e.preventDefault();
  validateNewsletterUnsubscribeEmailInputHandler();
  if (newsletterUnsubscribeValidForm === true) {
    const payloadEmailInputVal = newsletterUnsubscribeEmailInput?.value;
    if (!!payloadEmailInputVal) {
      sendNewsletterUnsubscription(payloadEmailInputVal);
    }
  } else {
    const invalidFormBanner = document.getElementById("invalid-form-banner");
    invalidFormBanner!.style.display = "flex";
    invalidFormBanner!.style.flexDirection = "column"
  }
}

/*                  */
function trackSubmitUnsubscribeNlSuccess() {
  submitEvent({
    user_Permission: ['Newsletter'],
    user_PermissionActivity: ['false_ok_unsubscribe'],
  });
}

function trackSubmitUnsubscribeNlFailure() {
  submitEvent({
    user_Permission: ['Newsletter'],
    user_PermissionActivity: ['false_error_unsubscribe'],
  });
}
